import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined'
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined'
import EventOutlinedIcon from '@mui/icons-material/EventOutlined'
import GridOnOutlinedIcon from '@mui/icons-material/GridOnOutlined'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import PsychologyOutlinedIcon from '@mui/icons-material/PsychologyOutlined'
import type { SvgIconComponent } from '@mui/icons-material'

export type ContentBlockType = 'date' | 'delivery-note' | 'file-attachment' | 'image' | 'mindset' | 'table' | 'todo'

export interface ContentBlockMenuItem {
   type: ContentBlockType
   label: string
   hint: string
   icon: SvgIconComponent
}

export const contentBlocks: ContentBlockMenuItem[] = [
   { type: 'date', label: 'Date', hint: 'A date or deadline', icon: EventOutlinedIcon },
   { type: 'delivery-note', label: 'Delivery note', hint: 'A guided callout for facilitators', icon: InfoOutlinedIcon },
   { type: 'file-attachment', label: 'File', hint: 'Attach a document', icon: AttachFileOutlinedIcon },
   { type: 'mindset', label: 'Mindset', hint: 'Add a guided reflection', icon: PsychologyOutlinedIcon },
   { type: 'table', label: 'Table', hint: 'A simple grid of rows and columns', icon: GridOnOutlinedIcon },
   { type: 'todo', label: 'To-do', hint: 'A checklist of action items', icon: CheckBoxOutlinedIcon },
]
